import { render, staticRenderFns } from "./limit_speed.vue?vue&type=template&id=fe144d08&scoped=true&"
import script from "./limit_speed.vue?vue&type=script&lang=js&"
export * from "./limit_speed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe144d08",
  null
  
)

export default component.exports